import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'rappider-crud-model-display',
  templateUrl: './crud-model-display.component.html',
  styleUrls: ['./crud-model-display.component.scss'],
})
export class RappiderCRUDModelDisplayComponent implements OnInit {

  @Input() data: any;
  @Input() formConfig: any;
  @Input() relations: any[];

  ngOnInit(): void {
  }

}
